/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createOurOfficesSectionStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: '#F6F7F8',
      padding: 'calc(100% * (80 / 1440)) calc(100% * (170 / 1440)) calc(100% * (160 / 1440))',
      overflow: 'hidden',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    title: {
      width: '100%',
      marginBottom: '120px',
      textAlign: 'center',
    },
    plxOurOffices: {
      width: '100%',
    },
    itemTitle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '18px',
      lineHeight: '36px',
      marginBottom: '6px',
      '& > span': {
        fontSize: '21px',
        paddingRight: '3px',
      },
    },
    itemListItem: {
      letterSpacing: 'normal',
      '& > p': {
        margin: 0,
      },
    },
  }),
);

export { createOurOfficesSectionStyles };
